import {MutableRefObject, useEffect, useState} from "react";
import {ApiQueryExecute, ApiQueryResponse} from "./UseApiQuery";
import {useSelector} from "react-redux";
import {ReduxStateInt} from "../Reducer/GlobalReducer";
import {useNavigate} from "react-router-dom";

export const API_QUERY_ABORT = -233
export interface ApiQueryMainResponse
{
    success:boolean;
    code: number;
    errorAsString: string;
    payload: any;
    id: string|null
    mimeType?:string|null
}

export interface IApiQueryControl
{
    (id:string):void
}

interface IApiQueryOption
{
    debug:boolean
    bundle?:Map<string,IApiQueryControl>
    single:boolean
}

interface IApiQueryOptionRequest
{
    debug?:boolean
    bundle?:Map<string,IApiQueryControl>
    single?:boolean
}


export interface IApiQueryExecute
{
    (id?:string|null):Promise<ApiQueryMainResponse>
}


//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
const useApiQueryFile = (query:string, data:MutableRefObject<any>, debug:boolean = false):[boolean,IApiQueryExecute]=>{
    const [result, setResult] = useState<ApiQueryMainResponse>({
        code:-200,
        errorAsString:"init",
        payload:null,
        id:null,
        success: false
    })

    const [isLoading, setLoading] = useState(false);
    const baseUrl = useSelector((state:ReduxStateInt)  => {return state.baseUrl});
    const authToken = useSelector((state:ReduxStateInt)  =>  {return state.authToken});
    const navigate = useNavigate()

    async function run(id:string|null = null):Promise<ApiQueryMainResponse>{
        const rs:ApiQueryMainResponse = {
            code:-200,
            errorAsString:"init",
            payload: null,
            id:id,
            success: false,

        }
        if(!query) {
            rs.code = -201
            rs.errorAsString = "Не корректный запрос"
            return rs
        }
        const fetchData = data?.current ? data?.current : {}
        const jsonData = createFetchData(1, fetchData)


        if(debug)console.log(`api post [${rs.id ? rs.id : ""}] data to server`,jsonData);


        setLoading(true);
        const bearerAuth = authToken ? authToken : localStorage.getItem('authToken')
        let header
        header =
            {
                'Accept': 'application/json',
                'Connection' : 'keep-alive',
                // Authorization' : "Bearer " + bearerAuth,
             //   'Content-Type': "application/json"
            }
        if(bearerAuth)header = {...header, 'Authorization':"Bearer " + bearerAuth}
        const url = `${baseUrl}${query}`

        try {
            const x = await fetch(url,
                {
                    headers: header,
                    method: "post",
                    credentials: 'include', //Включаем передачу куки и тп
                    mode: 'cors', //Используем политику cors
                    body: jsonData
                })
            const xResult = await parseJsonResponse(x , id, debug)
            if(xResult?.code === -150){
                navigate('/auth')
            }
            return xResult


        } catch (e) {
            rs.code = -205
            rs.payload = null
            rs.errorAsString = e ? e?.toString() : "Исключение fetch"
            return (rs)

        } finally {
            setLoading(false)

        }
    }
    return [isLoading,run]

}



//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
const useApiQueryPost = (query:string, data:MutableRefObject<any>, _opt?:IApiQueryOptionRequest):[boolean,IApiQueryExecute]=>{

    const defOp:IApiQueryOption = {
        debug: true,
        single: false,
    }


    const [isLoading, setLoading] = useState(false);
    const baseUrl = useSelector((state:ReduxStateInt)  => {return state.baseUrl});
    const authToken = useSelector((state:ReduxStateInt)  =>  {return state.authToken});
    const navigate = useNavigate()
    const [opt] = useState<IApiQueryOption>({...defOp,..._opt})



    async function run(id:string|null = null):Promise<ApiQueryMainResponse>{
        const xId = id ? id : Math.floor(Math.random()*90000+10000).toString()
        let abortAction = false
        const rs:ApiQueryMainResponse = {
            code:-200,
            errorAsString:"init",
            payload: null,
            id:xId,
            success: false,

        }
        if(!query) {
            rs.code = -201
            rs.errorAsString = "Не корректный запрос"
            return rs
        }
        const fetchData = data?.current ? data?.current : {}
        const jsonData = createFetchData(0, fetchData)


        if(opt.debug)console.log(`api post [${rs.id ? rs.id : ""}] data to server`,jsonData);


        setLoading(true);
        const bearerAuth = authToken ? authToken : localStorage.getItem('authToken')
        let header
        header =
            {
                'Accept': 'application/json',
                'Connection' : 'keep-alive',
              //  'Authorization' : "Bearer " + bearerAuth,
                'Content-Type': "application/json"
            }
        if(bearerAuth)header = {...header, 'Authorization':"Bearer " + bearerAuth}


        const url = `${baseUrl}${query}`
        const controller = new AbortController();
        const signal = controller.signal;
        try {
            if(opt?.single && opt?.bundle)
            {
                opt?.bundle?.forEach((item,idx)=>{
                    if(idx === id)item(idx)
                })
            }

            if(opt?.bundle){
                opt?.bundle?.set(xId, (id)=>{
                    controller.abort()
                })
            }

            const x = await fetch(url,
                {
                    headers: header,
                    signal:controller.signal,
                    method: "post",
                    credentials: 'include', //Включаем передачу куки и тп
                    mode: 'cors', //Используем политику cors
                    body: jsonData
                })
            const xResult = await parseJsonResponse(x , xId, opt.debug)
            if(xResult?.code === -150){
                navigate('/auth')
            }
            return xResult


        } catch (e:any) {
            //Если отменяем то ставим abortAction чтоб лоадер крутился
            rs.code = -205
            if(e?.name?.match(/abort/ui)) {
                rs.code = API_QUERY_ABORT
                abortAction = true
            }

            rs.payload = null
            rs.errorAsString = e ? e?.toString() : "Исключение fetch"
            return (rs)

        } finally {
            //if(!abortAction)setLoading(false)
            setLoading(false)
            if(opt?.bundle)opt?.bundle?.delete(xId)

        }
    }
    return [isLoading,run]

}

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
const useApiQueryGet = (query:string, data:MutableRefObject<any>, debug:boolean = false):[boolean,IApiQueryExecute]=>{
    const [result, setResult] = useState<ApiQueryMainResponse>({
        code:-200,
        errorAsString:"init",
        payload:null,
        id:null,
        success: false
    })

    const [isLoading, setLoading] = useState(false);
    const baseUrl = useSelector((state:ReduxStateInt)  => {return state.baseUrl});
    const authToken = useSelector((state:ReduxStateInt)  =>  {return state.authToken});
    const navigate = useNavigate()

    async function run(id:string|null = null):Promise<ApiQueryMainResponse>{
        const rs:ApiQueryMainResponse = {
            code:-200,
            errorAsString:"init",
            payload: null,
            id:id,
            success: false,

        }
        if(!query) {
            rs.code = -201
            rs.errorAsString = "Не корректный запрос"
            return rs
        }
        const fetchData = data.current ? data.current : {}
        const jsonData = createFetchData(2, fetchData)


        if(debug)console.log(`api get [${rs.id ? rs.id : ""}] data to server`,jsonData);


        setLoading(true);
        const bearerAuth = authToken ? authToken : localStorage.getItem('authToken')
        let header
        header =
            {
                'Accept': 'application/json',
                'Connection' : 'keep-alive',
                'Authorization' : "Bearer " + bearerAuth,
                'Content-Type': "application/json"
            }
        if(bearerAuth)header = {...header, 'Authorization':"Bearer " + bearerAuth}


        const url = `${baseUrl}${query}${jsonData ? `?${jsonData}` : ""}`
        try {
            const x = await fetch(url,
                {
                    headers: header,
                    method: "get",
                    credentials: 'include', //Включаем передачу куки и тп
                    mode: 'cors', //Используем политику cors
                })
            const xResult = await parseJsonResponse(x , id, debug)
            if(xResult?.code === -150){
                navigate('/auth')
            }
            return xResult


        } catch (e) {
            rs.code = -205
            rs.payload = null
            rs.errorAsString = e ? e?.toString() : "Исключение fetch"
            return (rs)

        } finally {
            setLoading(false)

        }
    }
    return [isLoading,run]

}

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!


const createFetchData = (mode:number, data: any)=>{
    if(! data) return null
    switch (mode)
    {
        case 0:
        {
            try {
                const x  = JSON.stringify(data)
                return x
            } catch (e) {
                return null
            }
        }
        case 1:
            return data
        case 2:
            try {
                const x = new URLSearchParams(data).toString()
                return x
            } catch (e)
            {
                return null
            }

        default : return null
    }
}
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

async function parseJsonResponse(xResult: Response, id:string|null, debug:boolean):Promise<ApiQueryMainResponse>{
    const rs:ApiQueryMainResponse = {
        code:-200,
        errorAsString:"init",
        payload:null,
        id:null,
        success: false
    }

    if(! xResult)
    {
        rs.code = -204
        rs.errorAsString = "Сервер не вернул данные"
        return (rs)
    }


    const isJson = xResult.headers.get('content-type')?.includes('application/json');
    if(! isJson)
    {
        rs.mimeType = xResult.headers.get('content-type')
        rs.payload = xResult
        rs.success = true
        rs.errorAsString = "OK"
        return rs

    }
    const rsData = isJson ? await xResult.json() : null
    if(debug)console.log(`api [${id ? id : ""}] data from server`,rsData);

    if(! rsData)
    {
        rs.code = -207
        rs.errorAsString = "Ошибка преобразования в json"
        return (rs)
    }
    if(!rsData?.success && rsData?.code === -150)
    {
        if(debug)console.log("\napi data from server : need auth... redirect to /auth\n")
        //navigate('/auth')
        return rs
    }
    rs.success = rsData?.success !== undefined ?  rsData?.success : false
    rs.payload = rsData?.payload !== undefined ? rsData?.payload : {}
    rs.code = rsData?.code !== undefined ? rsData?.code : rs.code
    rs.errorAsString = rsData?.errorAsString !== undefined ? rsData?.errorAsString : "Нет данных"
    return (rs)

}

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!


export  default {useApiQueryGet,useApiQueryPost,useApiQueryFile}
